// In Box.tsx
import { createBox } from '@shopify/restyle';

import { Theme } from '../../../themes/theme';

const Box = createBox<Theme>();

export default Box;
